/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod/v4";

export const socialProfileMatchedFactResponseDtoSchema = z.object({
    "field": z.enum(["name", "company", "title", "location"]),
"foundValue": z.string(),
"matchesContact": z.boolean()
    })